import React from 'react';
export default function Spinner() {
    return (
    <div className="pre-container">  
    <div className="overlay">
        <span className="loader">
        <img style={{width:"100px"}}src="Spinner-1s-201px.gif"/>
          </span>
    </div>
    </div>);
    } 